// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__21Hej","col":"styles_col__B1fJa","fulfillmentStatus":"styles_fulfillmentStatus__3cxZk","emailCol":"styles_emailCol__1jE-0"};